module.exports = __webpack_public_path__ + "static/media/slicks-n-slide.2ef5bff0.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/slicks-n-slide.webm
// module id = 58
// module chunks = 0